import { render, staticRenderFns } from "./EmployeeDetailsProxy.vue?vue&type=template&id=7734b628&"
import script from "./EmployeeDetailsProxy.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDetailsProxy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports